import * as Services from "../../../Service/Service";
import * as Url from "../../../Service/Url";

export const GetLargeCliamInvalidICD10ZipDetails = async () => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_INVALID_ICD10ZIP_DETAILS, token);
  return res;
};

export const DeleteInvalidICDZipcode = (payload) => {
  const token = localStorage.getItem("token");
  const { error_Value, error_Type, user_Name, license_ID, date_Created, date } =
    payload;
  const params = {
    error_Value,
    error_Type,
    user_Name,
    license_ID,
    date_Created,
    date,
  };

  let res = Services.DELETESERVICE(
    `/api/ACG_InvalidICD/DeleteData`,
    payload,
    token
  );
  return res;
};

export const DeleteAllInvalidICDZipcode = async () => {
  const token = localStorage.getItem("token");
  let res = await Services.DELETE(Url.DELETE_ALL_INVALID_ICDZIPCODE, token);
  return res;
};
